import { render, staticRenderFns } from "./ChartjsBarChartAdminClient.vue?vue&type=template&id=101ec111&"
import script from "./ChartjsBarChartAdminClient.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChartAdminClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports